
import { configureStore } from '@reduxjs/toolkit';
import { systemReducer } from './systemSlice';
import { authReducer } from './AuthSlice';
import { filterReducer } from './filterSlice';


const store = configureStore({
    reducer: {
        authTracking: authReducer,
        systemTracking: systemReducer,
        filter: filterReducer,
    },
});

export default store;
